import { DefaultTheme } from 'styled-components';
import { TFunction } from 'i18next';

export interface Invoice {
  id: number;
  packageName: string;
  price: number;
  from: string;
  to: string;
  paymentDate: string;
  number: string;
  adsCount: number;
  discount: number;
  vat: number;
  status: string;
}

export const invoices = [
  {
    id: 1,
    packageName: 'Basic',
    price: 300,
    from: '14.08.2023',
    to: '14.10.2023',
    paymentDate: '14.08.2023, 13:06, Yigim',
    number: '123456789',
    adsCount: 250,
    discount: 10,
    vat: 45.54,
    status: 'paid',
  },
  {
    id: 2,
    packageName: 'Basic',
    price: 1300,
    from: '14.08.2023',
    to: '14.10.2023',
    paymentDate: '14.08.2023, 13:06, Yigim',
    number: '123456789',
    adsCount: 250,
    discount: 10,
    vat: 45.54,
    status: 'unpaid',
  },
  {
    id: 3,
    packageName: 'Basic',
    price: 22300,
    from: '14.08.2023',
    to: '14.10.2023',
    paymentDate: '14.08.2023, 13:06, Yigim',
    number: '123456789',
    adsCount: 250,
    discount: 10,
    vat: 45.54,
    status: 'expired',
  },
];

export const renderStatus = (
  status: string,
  theme: DefaultTheme,
  t: TFunction
) => {
  switch (status) {
    case 'paid': {
      return {
        label: t('common.paid'),
        color: theme.palette.system.green,
      };
    }
    case 'unpaid': {
      return {
        label: t('common.unpaid'),
        color: theme.palette.system.red,
      };
    }
    case 'expired': {
      return {
        label: t('common.expired'),
        color: theme.palette.secondary.labels,
      };
    }

    default: {
      return {
        label: '',
        color: theme.palette.secondary.labels,
      };
    }
  }
};
